import { Fragment } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GREAT_WHITE, OBSIDIAN } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import AssigneeFilter from './AssigneeFilter';
import StatusFilter from './StatusFilter';
import ChannelFilter from './ChannelFilter';
import ContactFilter from './ContactFilter';
import DateFilter from './DateFilter';
import TrashToggle from './TrashToggle';
import FilteredToggle from './FilteredToggle';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import { DEFAULT_CHAT_FILTERS } from 'find-and-filter-data/search-and-filter-data/protected';
import Small from 'UIComponents/elements/Small';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickedClearFilter } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { VIEW_SELECTOR_FULL_WIDTH } from 'svh-workspace-ui-lib/collapsable-sidebar/public';
import InboxExitSearchAndFilterMode from './InboxExitSearchAndFilterMode';
import { ChannelInstanceIdFilter } from './ChannelInstanceIdFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeader = styled.h5.withConfig({
  displayName: "FilterSidebar__StyledHeader",
  componentId: "sc-128i8w0-0"
})(["color:", ";font-size:'14px';"], OBSIDIAN);
const SidebarContainer = styled.div.withConfig({
  displayName: "FilterSidebar__SidebarContainer",
  componentId: "sc-128i8w0-1"
})(["height:100%;width:", "px;overflow-y:auto;padding:0 20px 20px 20px;border-right:1px solid ", ";"], VIEW_SELECTOR_FULL_WIDTH, GREAT_WHITE);
const FilterSidebar = () => {
  const {
    clearFilterValues,
    filterValues
  } = useFilterValues();
  const handleClearFilterValues = () => {
    clearFilterValues();
    trackEvent(getClickedClearFilter());
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorLoggingTitle: "FilterSidebar",
    children: /*#__PURE__*/_jsxs(SidebarContainer, {
      children: [/*#__PURE__*/_jsx(InboxExitSearchAndFilterMode, {}), /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        children: [/*#__PURE__*/_jsx(UIFlex, {
          align: "start",
          children: /*#__PURE__*/_jsx(StyledHeader, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.title"
            })
          })
        }), /*#__PURE__*/_jsx(UIFlex, {
          align: "end",
          justify: "end",
          children: /*#__PURE__*/_jsx(UILink, {
            onClick: handleClearFilterValues,
            disabled: filterValues.delete('searchQuery').equals(DEFAULT_CHAT_FILTERS.delete('searchQuery')),
            "data-test-id": "search-and-filtering-clear-all",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.clear"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(StatusFilter, {}), /*#__PURE__*/_jsx(ChannelFilter, {}), /*#__PURE__*/_jsx(ChannelInstanceIdFilter, {}), /*#__PURE__*/_jsx(ContactFilter, {}), /*#__PURE__*/_jsx(AssigneeFilter, {}), /*#__PURE__*/_jsx(DateFilter, {}), /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(Small, {
          className: "display-inline-block m-top-6",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.moreOptions"
          })
        }), /*#__PURE__*/_jsx(FilteredToggle, {}), /*#__PURE__*/_jsx(TrashToggle, {})]
      })]
    })
  });
};
FilterSidebar.displayName = 'FilterSidebar';
export default FilterSidebar;